var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSortUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.055,
    height: 14.488,
    viewBox: "0 0 18.055 14.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#999;stroke-linecap:square;stroke-miterlimit:10;stroke-width:1.702px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.204 7.424)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -6.213)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.4,4.634,4.634,1.4,7.783,4.634",
    transform: "translate(-1.4 -1.4)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 11.489,
    transform: "translate(3.234 0.936)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 6.723,
    transform: "translate(9.277 12.426)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 4.34,
    transform: "translate(9.277 8.766)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 1.957,
    transform: "translate(9.277 5.106)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 0.255,
    transform: "translate(9.277 1.362)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortUp);
export default __webpack_public_path__ + "static/media/Icon-Sort-Up.e962e272.svg";
export { ForwardRef as ReactComponent };